import { createSlice } from '@reduxjs/toolkit'
import {
  clearAlertStore,
  clearAuthorizedUser,
  userAuthLogin,
  userAuthLogout,
  userAuthResetCheckToken,
  userAuthResetPassword,
  userAuthValidateToken,
  userAuthChangePassword,
  userCustomerAdminAuthChangePassword,
  userAuthResetAlertHandler,
  sendForgetPasswordEmail,
  validateResetPasswordToken,
  userResetPassword,
  userAuthTokenDecode,
} from './userAuthThunk'

const initialState = {
  alert: {},
  authorizedUser: {},
  loading: false,
}

const userAuthSlice = createSlice({
  name: 'userAuth',
  initialState,
  extraReducers: {
    [userAuthResetAlertHandler.fulfilled]: (state) => {
      state.alert = {}
    },
    [userAuthLogin.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthLogin.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthLogin.fulfilled]: (state) => {
      state.alert = {}
      state.loading = false
    },
    [userAuthTokenDecode.fulfilled]: (state, { payload }) => {
      state.alert = {}
      state.loading = false
      state.authorizedUser = {
        ...payload,
      }
    },
    [userAuthLogout.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthLogout.fulfilled]: (state) => {
      state.alert = {}
      state.loading = false
    },
    [clearAuthorizedUser.fulfilled]: (state) => {
      state.alert = {}
      state.loading = false
      state.authorizedUser = {}
    },
    [userAuthResetPassword.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthResetPassword.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthResetPassword.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [sendForgetPasswordEmail.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [sendForgetPasswordEmail.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [sendForgetPasswordEmail.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [validateResetPasswordToken.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [validateResetPasswordToken.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [validateResetPasswordToken.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },
    [userResetPassword.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userResetPassword.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userResetPassword.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthResetCheckToken.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthResetCheckToken.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthResetCheckToken.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthValidateToken.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthValidateToken.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthValidateToken.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },
    [clearAlertStore.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },
    [userAuthChangePassword.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userAuthChangePassword.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userAuthChangePassword.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },
    [userCustomerAdminAuthChangePassword.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [userCustomerAdminAuthChangePassword.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [userCustomerAdminAuthChangePassword.fulfilled]: (state) => {
      state.loading = false
      state.alert = {}
    },

  },
})

export const selectAuthUser = ({ userAuth }) => userAuth

export default userAuthSlice.reducer
